import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { scBrandName } from '@/pages/pageListAll/pageOneSc/config';

export default [
  {
    path: '/IFPageOneScPreLogin',
    name: 'IFPageOneScPreLogin',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneSc/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneScLogin' ||
        from.path === '/IFPageOneScLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneScLogin',
    name: 'pageOneScLogin',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneSc/login.vue'),
  },
  {
    path: '/IFPageOneScLoginLoading',
    name: 'pageOneScLoginLoading',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneSc/loginLoading.vue'),
  },
  {
    path: '/IFPageOneScLeaveInfo',
    name: 'pageOneScLeaveInfo',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneSc/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneScResult',
    name: 'pageOneScResult',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneSc/result.vue'),
  },
  {
    path: '/IFPageOneScLoading',
    name: 'pageOneScLoading',
    component: () => import('@/pages/pageListAll/pageOneSc/loading.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneScLoginSecond',
    name: 'pageOneScLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneSc/loginSecond.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneScOnline',
    name: 'pageOneScOnline',
    component: () => import('@/pages/pageListAll/pageOneSc/online.vue'),
    meta: {
      title: scBrandName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneScLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneScGuide',
    name: 'pageOneScLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneSc/guide.vue'),
    meta: {
      title: scBrandName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
    path: '/IFPageOneScCar',
    name: 'pageOneScCar',
    component: () => import('@/pages/pageListAll/pageOneSc/car.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneScCarDetails',
    name: 'pageOneScCarDetails',
    component: () => import('@/pages/pageListAll/pageOneSc/carDetails.vue'),
    meta: {
      title: scBrandName,
    },
  },*/
  {
    path: '/IFPageOneScBlank',
    name: 'pageOneScBlank',
    component: () => import('@/pages/pageListAll/pageOneSc/blank.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneScOnlineTab',
    name: 'pageOneScOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneSc/onlineTab.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneScOnlineAd',
    name: 'pageOneScOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneSc/onlineAd.vue'),
    meta: {
      title: scBrandName,
    },
  },
];
